<template>
    <v-sheet elevation="1" rounded class="overflow-hidden">
        <v-toolbar flat dense class="secondary">
            <v-toolbar-title>Stock Journal Roles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <PIconBtn icon="mdi-plus" tooltip="Add Role" @click="handleAddingRole"/>
                <v-spacer></v-spacer>
            </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="py-4" draggable>
            <v-data-table
                dense
                @click:row="handleRowClick"
                :headers="headers"
                :items="roles">
            </v-data-table>
        </div>
        <v-dialog
            scrollable
            v-model="stockJournalRoleEditShown">
            <StockJournalRoleEdit :role="selectedRole" v-if="stockJournalRoleEditShown" @close="handleClose"/>
        </v-dialog>
        <v-snackbar v-model="snackbar.display" bottom right :color="snackbar.color">{{snackbar.message}}</v-snackbar>
    </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PIconBtn from './../common/PIconBtn';
import StockJournalRoleEdit from './../warehouse/StockJournalRoleEdit';

export default {
    name: "StockJournalRolesList",
    components: { PIconBtn, StockJournalRoleEdit },
    data() {
        return {
            headers: [
                { text: "Role", value: "name" },
                { text: "Last Update", value: "updated_at" },
            ],
            stockJournalRoleEditShown: false,
            baseRole: {
                id: null,
                name: "",
                accounts: [],
                warehouses: [],
                users: [],
                items: []
            },
            selectedRole: {},
            snackbar: { display: false, color: "", message: "" },
        }
    },
    computed: {
        ...mapGetters("stockJournal/role", ["roles", "loading"])
    },
    methods: {
        ...mapActions("stockJournal/role", ["fetchRoles"]),
        handleAddingRole() {
            this.selectedRole = this.baseRole;
            this.stockJournalRoleEditShown = true;
        },
        handleRowClick(role) {
            this.selectedRole = role;
            this.stockJournalRoleEditShown = true;
        },
        handleClose({snackbar}) {
            this.stockJournalRoleEditShown = false;
            if(snackbar) this.snackbar = snackbar;
        }
    },
    mounted() {
        this.fetchRoles();
    }
}
</script>

<style>

</style>